import React, { useEffect, useState } from 'react';
import Product from '../Product/Product';

const NewArival = () => {

    const [ arrival , setArrival] = useState([]);

    useEffect( ()=>{
        fetch('newarival.json')
        .then(res => res.json())
        .then(data => setArrival(data))
        .catch((err) => console.error(err))
    } ,[])
    const handleAddToCart = (product) =>{
        console.log(product)
    }
       
    return (
        <section className="new-arrival mb-10">
        <div className="container mx-auto">
            <h2 className="text-4xl font-bold">
            NEW ARRIVALS 
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4 my-10">
                         
            {
                        arrival.map( product => <Product                        
                        key={product.id}
                        product = {product}
                        handleAddToCart = {handleAddToCart}
                        >

                        </Product>)
                    }

			</div>
        </div>
    </section>
    );
};

export default NewArival;